import { Select } from "antd";
import React from "react";

const { Option } = Select;

export const statusOptions = [
  { value: "pending", label: "Under Review", color: "#FFECB3" },
  { value: "qualified", label: "Qualified", color: "#81C784" },
  { value: "disqualified", label: "Disqualified", color: "#E57373" },
  {
    value: "awaiting_submission",
    label: "Awaiting Submission",
    color: "#64B5F6",
  },
  // …add more here
];

// Utility to pick a legible text color on top of your status color
const textColorFor = (bg) => {
  const c = bg
    .substring(1)
    .match(/.{2}/g)
    .map((h) => parseInt(h, 16));

  const lum = 0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2];

  // Lower threshold → black text used on light backgrounds like #FFECB3
  return lum > 140 ? "#000" : "#fff";
};

const StatusDropdown = ({ value, onChange, style = {} }) => {
  const current = statusOptions.find((s) => s.value === value) || {};

  return (
    <Select
      value={value}
      onChange={onChange}
      optionLabelProp="label"
      dropdownMatchSelectWidth={false}
      style={{
        width: 180,
        backgroundColor: current.color || "#fff",
        color: textColorFor(current.color || "#fff"),
        border: `1px solid ${current.color || "#ccc"}`,
        borderRadius: 4,
        ...style,
      }}
    >
      {statusOptions.map(({ value, label, color }) => {
        const textColor = textColorFor(color);
        const labelNode = (
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: color,
                display: "inline-block",
                marginRight: 8,
              }}
            />
            <span style={{ color: textColor }}>{label}</span>
          </span>
        );

        return (
          <Option key={value} value={value} label={labelNode}>
            {labelNode}
          </Option>
        );
      })}
    </Select>
  );
};

export default StatusDropdown;
